import CustomButton from '@/partials/custom_button';

import Button from '@/components/button';
import { Modal } from '@/components/modal';
import InteractivePanel from '@/components/interactive_panel';


export default {

	props: {
		confirm_modal: {
			type: Object,
			required: true,
		},

		title: {
			type: String
		},
	},


	components: {
		'p-custom-button': CustomButton,

		'c-button': Button,
		'c-modal': Modal,
		'c-interactive-panel': InteractivePanel,
	},


	methods: {
		/** 取消事件 */
		async on_cancel(event) {
			this.confirm_modal.toggle();

			this.$emit('cancel', event)
		},

		/** 确认事件 */
		async on_confirm(event) {
			this.confirm_modal.toggle();

			this.$emit('confirm', event)
		},
	},

};
